/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type CardAccountAccountType = typeof CardAccountAccountType[keyof typeof CardAccountAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountAccountType = {
  'asset-link': 'asset-link',
  prepaid: 'prepaid',
  'fixed-limit': 'fixed-limit',
} as const;
